const state = () => ({
  orderModal: {
    visible: false,
    orderId: null
  }
})

const mutations = {
  OPEN_ORDER_MODAL(state, orderId) {
    state.orderModal.visible = true
    state.orderModal.orderId = orderId
  },
  CLOSE_ORDER_MODAL(state) {
    state.orderModal.visible = false
    state.orderModal.orderId = null
  }
}

const actions = {
  openOrderModal({ commit }, orderId) {
    commit('OPEN_ORDER_MODAL', orderId)
  },
  closeOrderModal({ commit }) {
    commit('CLOSE_ORDER_MODAL')
  }
}

const getters = {
  orderModalVisible: (state) => state.orderModal.visible,
  activeOrderId: (state) => state.orderModal.orderId
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};